import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom';
import TopTitleBar from './TopTitleBar'
import ProfileForm from '../../../components/DashBoard/ProfileForm';
import API from '../../../ApiConfig'
import { BASE_URL, GET_ISSUER, GET_VERIFIER, USER_TOKEN } from '../../../Utils/constant'
import { useSelector } from "react-redux";

import cogoToast from 'cogo-toast-react-17-fix';
import Loader from '../../../components/Loader';
import { Delay } from '../../../Utils/helper';
import SlideUpWrapper from '../../../components/Transitions/SlideUpWrapper';
import useRefreshToken from '../../../Hooks/usegenerateToken';

export default function Profile({ }) {
    useRefreshToken(BASE_URL + USER_TOKEN)
    const [companyProfile, setcompanyProfile] = useState({ name: null })
    const User = useSelector(state => state.User)
    let { id } = useParams();
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        window.scrollTo(0, 0);
        if (!companyProfile.name) {
            getProfile()
        }

    }, [])
    async function getProfile() {
        let URL = User.user_type === 'Verifier' ? GET_VERIFIER : GET_ISSUER
        setLoading(true)
        await Delay()
        API.get(URL + id)
            .then(res => {
                setLoading(false)
                if (res.data.status === 200) {
                    let data = res.data.data
                    setcompanyProfile(data)
                }

            })
            .catch(err => {
                setLoading(false)
                cogoToast.error('Something went wrong while fetching profile details!')
            })
    }
    return (
        <>
            <SlideUpWrapper>
                <TopTitleBar isChild ><h2 className="topTitleBarText"><span className='secondaryButton1'>Profile</span></h2></TopTitleBar>
                <ProfileForm isProfileUser companyProfile={companyProfile} />
            </SlideUpWrapper>

        </>
    )
}
